import {useCallback, useMemo} from "react";
import {useSelector} from "../../../__snowpack__/pkg/react-redux.js";
import {useAppDispatch} from "../store.js";
import {selectAccountFilters, selectWhiteLabelFilters} from "./filters.selectors.js";
import {filtersStore} from "./filters.slice.js";
function useGenericFiltersHook(selector, actionSet, actionReset) {
  const dispatch = useAppDispatch();
  const state = useSelector(selector);
  return [useMemo(() => ({
    ...state
  }), [state]), useCallback((newState) => dispatch(actionSet(newState)), [actionSet, dispatch]), useCallback(() => dispatch(actionReset()), [actionReset, dispatch])];
}
export function useReduxFiltersReset() {
  const dispatch = useAppDispatch();
  return useCallback(() => dispatch(filtersStore.actions.resetFilters()), [dispatch]);
}
export function useReduxFiltersWhiteLabel() {
  return useGenericFiltersHook(selectWhiteLabelFilters, filtersStore.actions.setWhiteLabelFilters, filtersStore.actions.resetWhiteLabelFilters);
}
export function useReduxFiltersAccount() {
  return useGenericFiltersHook(selectAccountFilters, filtersStore.actions.setAccountFilters, filtersStore.actions.resetAccountFilters);
}
